export default __webpack_public_path__ + "7c43ff49dfa64778578655da9110bbff.babylon";